import Immutable from 'immutable';
import {
  FLAG_GETTING_ITINERARY_TYPES,
  GET_ITINERARY_TYPES,
  CLEAR_ITINERARY_TYPES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Set(),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_ITINERARY_TYPES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_ITINERARY_TYPES:
      return state.setIn(['all', 'content'], Immutable.Set(action.payload));
    case CLEAR_ITINERARY_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map());
    default:
      return state;
  }
};
